"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.colorStyles = void 0;
var colorStyles = exports.colorStyles = Object.freeze({
  DEFAULT: '#e4e5e9',
  ANGRY: '#f64d52',
  SAD: '#FF8C00',
  NEUTRAL: '#FCD116',
  SMILE: '#C8F526',
  HAPPY: '#99CC32',
  REQUIRED: '#ff0000',
  STAR: '#f7c221'
});
var _default = exports["default"] = colorStyles;
//# sourceMappingURL=colorStyles.js.map